import React from 'react'
import PropTypes from 'prop-types'
import { Collapse } from 'antd'
import TableTemplate from './TableTemplate'
import { BLOCK_LABELS, formatNumber } from './blockConfig'

const { Panel } = Collapse
const MAX_COLUMNS = 4
const MIN_ROWS_PER_COLUMN = 8

const _sortItems = (items) => {
    return [...items].sort((a, b) => {
        if (b.total !== a.total) return b.total - a.total
        return a.type.localeCompare(b.type)
    })
}

// Mỗi cột tối thiểu ~8 dòng (theo mockup FAC-M12-mockup-chua-phan-lo.html) — khối ít SKU
// chỉ dùng 1-2 cột thay vì luôn chia đủ 4 cột nửa rỗng.
const _splitIntoColumns = (items, maxColumns, minRowsPerColumn) => {
    if (items.length === 0) return []
    const usedColumns = Math.max(1, Math.min(maxColumns, Math.ceil(items.length / minRowsPerColumn)))
    const perColumn = Math.ceil(items.length / usedColumns)
    const columns = []
    for (let i = 0; i < usedColumns; i++) {
        const columnData = items.slice(i * perColumn, (i + 1) * perColumn)
        if (columnData.length > 0) columns.push(columnData)
    }
    return columns
}

function CommitBlock({ block, loading, isFiltered, isOpen, onToggle }) {
    const label = BLOCK_LABELS[block.block]
    const sortedItems = _sortItems(block.items || [])
    const columns = _splitIntoColumns(sortedItems, MAX_COLUMNS, MIN_ROWS_PER_COLUMN)
    const shownCount = sortedItems.length

    const header = (
        <div className={`BlockHeader ${label.emphasize ? 'Emphasized' : ''}`}>
            <span className="BlockTitle">{label.title}</span>
            <span className="BlockMeta">
                {' '}— {formatNumber(block.total)} items
                {label.hideSkuCount ? '' : ` · ${formatNumber(block.skuCount)} SKU`}
                {isFiltered ? ` · đang hiện ${formatNumber(shownCount)}` : ''}
            </span>
            {label.badge && <span className="BlockBadge">{label.badge}</span>}
        </div>
    )

    return (
        <div id={`block-${block.block}`} className="CommitBlock">
            <Collapse
                activeKey={isOpen ? [block.block] : []}
                onChange={(keys) => onToggle(block.block, keys.includes(block.block))}
            >
                <Panel header={header} key={block.block}>
                    {shownCount === 0 ? (
                        <div className="NoMatch">Không có SKU nào khớp bộ lọc.</div>
                    ) : (
                        <div className="TableStatics Column4 d-flex justify-content-start">
                            {columns.map((columnData, index) => (
                                <TableTemplate key={index} data={columnData} loading={loading} error="" commitBlock={block.block} />
                            ))}
                        </div>
                    )}
                </Panel>
            </Collapse>
        </div>
    )
}

CommitBlock.propTypes = {
    block: PropTypes.shape({
        block: PropTypes.string.isRequired,
        total: PropTypes.number,
        skuCount: PropTypes.number,
        overdueCount: PropTypes.number,
        items: PropTypes.array,
    }).isRequired,
    loading: PropTypes.any,
    isFiltered: PropTypes.bool,
    isOpen: PropTypes.bool,
    onToggle: PropTypes.func.isRequired,
}

export default CommitBlock
